module.exports = __webpack_public_path__ + "static/media/metop_cover.756e866a.png";